// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface CloudDownloadIconSignature {
  Element: SVGSVGElement;
}

export const CloudDownloadIcon: TOC<CloudDownloadIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20 7C20 3.141 16.859 0 13 0C10.143 0 7.643 1.699 6.562 4.253C6.061 4.086 5.533 4 5 4C2.243 4 0 6.243 0 9C0 11.757 2.243 14 5 14H13C16.859 14 20 10.86 20 7ZM13 12H5C3.346 12 2 10.654 2 9C2 7.346 3.346 6 5 6C5.571 6 6.131 6.166 6.617 6.48C6.892 6.657 7.233 6.69 7.535 6.567C7.838 6.445 8.06 6.183 8.135 5.867C8.663 3.59 10.664 2 13 2C15.757 2 18 4.243 18 7C18 9.757 15.757 12 13 12ZM19 19.586L21.293 17.293L22.707 18.707L18 23.414L13.293 18.707L14.707 17.293L17 19.586V14H19V19.586Z"/>
</svg>
</template>;